import { render, staticRenderFns } from "./OfficeManagement.vue?vue&type=template&id=8b848d34&"
import script from "./OfficeManagement.vue?vue&type=script&lang=js&"
export * from "./OfficeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports